import React, { useEffect, useState } from 'react'
import Topbar from './Topbar'
import { Link, useNavigate } from 'react-router-dom'
import $ from 'jquery'
import Sidebar_component from './Sidebar_component'

export default function Goal_details() {
    const [detailsGoals, setDetailsGoals] = useState([]);
    const [milestones, setMilestones] = useState([]);
    const [files, setFiles] = useState([]);
    const [comments, setComments] = useState([]);
    const [newComment, setNewComment] = useState('');
    const [loggedUserId, setLoggedUserId] = useState(null);
    const [sidebarOpen, setSidebarOpen] = useState(false);

    const navigate = useNavigate();
    useEffect(() => {

        const goalId = localStorage.getItem('goal_id');
        const userId = localStorage.getItem('member_id');
        const companyId = localStorage.getItem('mem_company_id');
        const userType = localStorage.getItem('user_position');

        setLoggedUserId(userId);

        console.log('goal_id: ' + goalId + ' || member_id: ' + userId + ' || mem_company_id: ' + companyId + ' || user_position: ' + userType)

        console.log(goalId)

        $.ajax({
            type: 'POST',
            url: 'getGoalFullDetails.php',
            data: {
                goal_id: goalId,
                user_id: userId,
                company_id: companyId,
                user_type: userType
            },
            success: function (res) {
                console.log(res);
                if (res.success) {

                    setDetailsGoals(res.goal);
                    setMilestones(res.milestones);
                    setFiles(res.files);
                    setComments(res.comments);

                } else {

                    showAlert(res.message);
                }
            }
        });

    }, []);


    function showAlert(msg) {
        $('#alertpop').css('display', 'block');
        $('#alert_text').text(msg);
    }

    function closeAlert() {
        $('#alertpop').css('display', 'none');
        $('#alert_text').text('');
    }

    const formatDate = (dateString) => {
        if (!dateString) return '';
        return dateString.split(' ')[0];
    };

    const addComment = () => {

        if (!newComment.trim()) return;

        $.ajax({

            type: 'POST',
            url: 'addGoalComment.php',

            data: {
                goal_id: detailsGoals.id,
                user_id: localStorage.getItem('member_id'),
                comment: newComment
            },

            success: function (res) {

                if (res.success) {

                    setComments([res.comment, ...comments]);
                    setNewComment('');

                } else {

                    showAlert(res.message);
                }
            }
        });
    };

    function goToLinkedProject(id, proname) {
        if (id < 1) {
            showAlert('There is no linked project');
        } else {
            localStorage.setItem('selected_project_id', id);
            localStorage.setItem('selected_project_name', proname);
            localStorage.setItem('initialpage', 'members');
            navigate('/project_details');
        }
    }

    function goForLinkedTask(id) {
        if (id < 1) {
            showAlert('There is no linked task');
        } else {
            localStorage.setItem('taskid', id);
            navigate('/task_details');
        }
    }

    function editgoals() {
        const goalId = localStorage.getItem('goal_id');
        navigate('/edit_goal');
    }

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    return (
        <div>
            <Topbar toggleSidebar={toggleSidebar} />
            <Sidebar_component sidebarOpen={sidebarOpen} />
            <div className='vl_dsh_bodypart'>
                <div className='vl_alltab'>
                    <h2 className='bigfonttabs'>Goal Details</h2>
                    <Link className='pull_right add_new_pro' to="/goals">View Goals</Link>
                    {detailsGoals?.user_id == loggedUserId && (
                        <button
                            className='pull_right add_new_pro editbtn'
                            onClick={editgoals}
                        >
                            Edit Goal
                        </button>
                    )}
                </div>
                <section className='vl_dsh_bodypart_section'>
                    <div className='vl_dsh_container'>
                        <div className='vl_dsh_one_row'>

                            <div className='vl_dsh_one_half'>

                                <div className='inforow'>
                                    <p className='titlebox'>Goal Title:</p>
                                    <p className='detailbox'>{detailsGoals.title}</p>
                                </div>

                                <div className='inforow'>
                                    <p className='titlebox fullwidth'>Goal Description:</p>
                                    <p className='detailbox fullwidth'>
                                        {detailsGoals.description}
                                    </p>
                                </div>

                                <div className='inforow'>
                                    <p className='titlebox'>Goal Creator:</p>
                                    <p className='detailbox'>
                                        {detailsGoals.member_name || 'N/A'}
                                    </p>
                                </div>

                                <div className='inforow'>
                                    <p className='titlebox'>Goal Category:</p>
                                    <p className='detailbox'>{detailsGoals.category}</p>
                                </div>

                                <div className='inforow'>
                                    <p className='titlebox'>Goal Priority:</p>
                                    <p className='detailbox'>{detailsGoals.priority}</p>
                                </div>

                            </div>


                            <div className='vl_dsh_one_half'>

                                <div className='inforow'>
                                    <p className='titlebox'>Goal Status:</p>
                                    <p className='detailbox'>{detailsGoals.status}</p>
                                </div>

                                <div className='inforow'>
                                    <p className='titlebox'>Start:</p>
                                    <p className='detailbox'>{detailsGoals.start_date}</p>

                                    <p className='titlebox'>End:</p>
                                    <p className='detailbox'>{detailsGoals.end_date}</p>
                                </div>

                                <div className='inforow'>
                                    <p className='titlebox'>Goal Progress:</p>
                                    <p className='detailbox'>
                                        {detailsGoals.progress}%
                                    </p>
                                </div>


                                <div className='inforow'>
                                    <p className='titlebox'>Created At:</p>
                                    <p className='detailbox'>
                                        {formatDate(detailsGoals.created_at)}
                                    </p>
                                </div>

                                <div className='inforow'>
                                    <p className='titlebox'>Last Update At:</p>
                                    <p className='detailbox'>
                                        {formatDate(detailsGoals.updated_at)}
                                    </p>
                                </div>
                                <div className="inforow">
                                    <p className="titlebox">Linked Project:</p>
                                    <p className="detailbox">
                                        {detailsGoals.project_name || "Not Linked"}
                                    </p><button className='small_button ml-10' onClick={() => { goToLinkedProject(detailsGoals.project_id, detailsGoals.project_name) }}>View Project</button>
                                </div>
                                <div className="inforow">
                                    <p className="titlebox">Linked Task:</p>
                                    <p className="detailbox">
                                        {detailsGoals.task_name || "Not Linked"}
                                    </p><button className='small_button ml-10' onClick={() => { goForLinkedTask(detailsGoals.task_id) }}>View Task</button>
                                </div>

                            </div>

                        </div>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_half mt-50 milestones'>
                                <h2>Milestones</h2>

                                {milestones.length === 0 && <p>No milestones</p>}

                                {milestones.map(ms => (

                                    <div key={ms.id} className="milestone-box">
                                        <div className='inforow'>
                                            <h3 className='titlebox'>Title:</h3>
                                            <p className='detailbox'>{ms.title}</p>
                                        </div>
                                        <div className='inforow'>
                                            <p className='titlebox fullwidth'>Description:</p>
                                            <p className='detailbox fullwidth'>{ms.description}</p>
                                        </div>
                                        <div className='inforow'>
                                            <p className='titlebox'>Due:</p>
                                            <p className='detailbox'>{ms.due_date}</p>
                                        </div>
                                        <div className='inforow'>
                                            <h3 className='titlebox'>Status:</h3>
                                            <p className='detailbox'>{ms.status}</p>
                                        </div>
                                        <div className='inforow'>
                                            <h3 className='titlebox'>Created at:</h3>
                                            <p className='detailbox'>{formatDate(ms.created_at)}</p>
                                        </div>
                                        <div className='inforow'>
                                            <h3 className='titlebox'>Completed at:</h3>
                                            <p className='detailbox'>{formatDate(ms.completed_at)}</p>
                                        </div>

                                    </div>
                                ))}

                            </div>
                        </div>

                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_full mt-50 milestones'>
                                <h2>Files</h2>
                                <div className="milestone-box">
                                    <h3>Files</h3>

                                    {files.length === 0 && <p>No files uploaded</p>}

                                    {files.map(file => (

                                        <div key={file.id} className="file-box">

                                            <span>{file.file_name}</span>

                                            <a
                                                href={file.file_path}
                                                download
                                                target="_blank"
                                            >

                                                Download
                                            </a>

                                        </div>
                                    ))}

                                </div>
                            </div>
                        </div>
                        <div className='vl_dsh_one_row'>
                            <div className='vl_dsh_one_full mt-50 milestones '>
                                <h2>Comments</h2>
                                <div className='milestone-box'>
                                    {comments.length === 0 && <p>No comments yet</p>}
                                    {comments.map(c => (
                                        <div key={c.id} className="comment-box">
                                            <strong>{c.member_name}</strong>
                                            <p>{c.comment}</p>
                                            <small>{formatDate(c.created_at)}</small>

                                        </div>
                                    ))}
                                </div>

                            </div>
                            <div className='vl_dsh_one_full mt-20'>
                                <div className='query_form'>
                                    <div className='formfieldholder'>
                                        <label>Insert your comment</label>
                                        <textarea
                                            value={newComment}
                                            onChange={e => setNewComment(e.target.value)}
                                            placeholder="Write a comment..."
                                        />

                                        <button className='mt-15 editbtn' onClick={addComment}>
                                            Post Comment
                                        </button>

                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>
            </div>
            <div className='vl_dsh_popup' id="alertpop">
                <div className='alertbox'>
                    <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
                    <div className='contentarea'>
                        <p id="alert_text"></p>
                    </div>
                    <div className='alert_btns'>
                        <button onClick={closeAlert}>Okay</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
